/**
 * SubPage
 * 서브 페이지 전용 애니메이션 클래스
 */
export class SubPage {
    constructor() {
        this.stickyBarObserver = null;
    }

    /**
     * Hero 섹션
     * sub-hero pin / ScrollTrigger 애니메이션 제거 (정적 표시)
     */
    hero() {
        this.initStickySolutionBar();
    }

    /**
     * Sticky solution bar (스크롤 시 상단 고정)
     * 히어로를 스크롤로 지나가면 표시 (pin 구간 포함)
     */
    initStickySolutionBar() {
        const stickyBar = document.getElementById("solution-sticky-bar");
        const heroSection = document.querySelector(".no-sub-hero");
        const contentSection = document.querySelector(".no-sub-module");
        if (!stickyBar || !heroSection) return;

        const showBar = () => stickyBar.classList.add("is-visible");
        const hideBar = () => stickyBar.classList.remove("is-visible");

        if (typeof ScrollTrigger !== "undefined") {
            ScrollTrigger.create({
                trigger: contentSection || heroSection,
                start: "top 15%",
                end: "top top",
                onEnter: showBar,
                onLeaveBack: hideBar,
            });
        } else {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((e) => {
                        e.isIntersecting ? hideBar() : showBar();
                    });
                },
                { rootMargin: "-15% 0px 0px 0px" }
            );
            observer.observe(heroSection);
            this.stickyBarObserver = observer;
        }
    }

    /**
     * 정리
     */
    destroy() {
        if (this.stickyBarObserver) {
            const heroSection = document.querySelector(".no-sub-hero");
            if (heroSection) this.stickyBarObserver.unobserve(heroSection);
            this.stickyBarObserver = null;
        }
        document.getElementById("solution-sticky-bar")?.classList.remove("is-visible");

        // ScrollTrigger 정리
        if (typeof ScrollTrigger !== "undefined") {
            ScrollTrigger.getAll().forEach((trigger) => {
                if (trigger.vars && trigger.vars.trigger) {
                    const triggerEl = trigger.vars.trigger;
                    if (
                        triggerEl &&
                        triggerEl.classList &&
                        triggerEl.classList.contains("no-sub-hero")
                    ) {
                        trigger.kill();
                    }
                }
            });
        }
    }
}
